// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDRIzCWslTVy_KBhF-SozVz53UMFDNfHiM",
  authDomain: "pocketdimensionsociety.firebaseapp.com",
  projectId: "pocketdimensionsociety",
  storageBucket: "pocketdimensionsociety.appspot.com",
  messagingSenderId: "502140269682",
  appId: "1:502140269682:web:693ce87af054a92a29feeb",
  measurementId: "G-FDZWB8VQNT"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

export const db = getFirestore(firebaseApp);